var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dial-back-input" },
    [
      _c("day-range-popup", {
        attrs: {
          "is-visible": _vm.isPopupOpen,
          "date-range": _vm.dateRange,
          "is-paused": _vm.isPaused,
          "dial-back-hours": _vm.dialBackHours,
        },
        on: {
          "date-range-change": _vm.handleDateRangeChange,
          "popup-close": _vm.handlePopupClose,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("media-buttons", {
            attrs: {
              "is-active": _vm.isLive,
              "is-paused": _vm.isPaused,
              "is-rewind-disabled": _vm.isBackDisabled,
              "is-fast-forward-disabled": _vm.isForwardDisabled,
            },
            on: {
              "pause-clicked": _vm.pauseHandler,
              "play-clicked": _vm.playHandler,
              "rewind-clicked": _vm.rewindHandler,
              "fast-forward-clicked": _vm.fastForwardHandler,
            },
          }),
          _vm._v(" "),
          _c("status-bar", {
            staticClass: "live-status-bar",
            attrs: { "is-active": _vm.isLive },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c(
            "button",
            { staticClass: "timeDisplayButton", on: { click: _vm.openPopup } },
            [
              _vm._v("\n        " + _vm._s(_vm.getTimeLabel(_vm.dateRange))),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDownsampling && _vm.showDownsamplingLink,
                      expression: "showDownsampling && showDownsamplingLink",
                    },
                  ],
                },
                [_vm._v(" *")]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-caret-down pull-right" }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "down-sampling-wrapper" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showDownsampling && _vm.showDownsamplingLink,
                  expression: "showDownsampling && showDownsamplingLink",
                },
              ],
              staticClass: "down-sampling-span",
            },
            [
              _vm._v("\n        * "),
              _c(
                "a",
                {
                  staticClass: "down-sampling-link",
                  attrs: { href: _vm.downsamplingLinkHref, target: "_blank" },
                },
                [_vm._v("Downsampling")]
              ),
              _vm._v(" is in effect\n      "),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }